import { createQueryKeys } from '@lukemorales/query-key-factory';

import type {
  FetchMarketplacePurchasesArgs,
  FetchMarketplaceSalesArgs,
} from '../api/types/payments.types';
import type {
  FetchOrgMarketplacePayoutsArgs,
  FetchOrgPayoutStatementsArgs,
} from '../api/marketplacePayments.api';

import {
  fetchRecipientOnboardingAccountCountries,
  fetchMarketplacePurchases,
  fetchMarketplaceSales,
  fetchRecipientOnboarding,
  fetchMarketplaceListingCurrency,
  fetchAdminOnboardings,
  fetchOrgMarketplacePayouts,
  fetchOrgPayoutStatements,
} from '../api/marketplacePayments.api';

export const marketplacePaymentsQueryKeys = createQueryKeys(
  'marketplacePayments',
  {
    // superadmin lista zahteva (R-AUD-69)
    fetchAdminOnboardings: ({ status }: { status?: string }) => ({
      queryFn: () => fetchAdminOnboardings({ status }),
      queryKey: [status ?? 'all'],
    }),
    fetchPurchases: (args: FetchMarketplacePurchasesArgs) => ({
      queryFn: () => fetchMarketplacePurchases(args),
      queryKey: [args],
    }),
    fetchSales: (args: FetchMarketplaceSalesArgs) => ({
      queryFn: () => fetchMarketplaceSales(args),
      queryKey: [args],
    }),
    fetchRecipientOnboarding: ({
      organizationId,
    }: {
      organizationId: string;
    }) => ({
      queryFn: () => fetchRecipientOnboarding({ organizationId }),
      queryKey: [organizationId],
    }),
    fetchMarketplaceListingCurrency: ({
      organizationId,
    }: {
      organizationId: string;
    }) => ({
      queryFn: () => fetchMarketplaceListingCurrency({ organizationId }),
      queryKey: [organizationId],
    }),
    fetchRecipientOnboardingAccountCountries: ({
      organizationId,
    }: {
      organizationId: string;
    }) => ({
      queryFn: () =>
        fetchRecipientOnboardingAccountCountries({ organizationId }),
      queryKey: [organizationId],
    }),
    fetchOrgMarketplacePayouts: ({
      organizationId,
      limit,
      offset,
    }: FetchOrgMarketplacePayoutsArgs) => ({
      queryFn: () =>
        fetchOrgMarketplacePayouts({ organizationId, limit, offset }),
      queryKey: [organizationId, limit, offset],
    }),
    fetchOrgPayoutStatements: ({
      organizationId,
      limit,
      offset,
    }: FetchOrgPayoutStatementsArgs) => ({
      queryFn: () =>
        fetchOrgPayoutStatements({ organizationId, limit, offset }),
      queryKey: [organizationId, limit, offset],
    }),
  },
);
